export * from "./MiniPlacehoder";